import { useNavigate } from 'react-router-dom';

import { useMediaCenterPathContext } from 'hb-react/frontoffice/apps/MediaCenter/contexts/MediaCenterPathContext';
import FilePreview from 'hb-react/shared/components/FilePreview';

const LoadingOrNotFound = ({ fileNotFound, folderUuid }) => {
  const { mediaCenterFolderPath } = useMediaCenterPathContext();
  const navigate = useNavigate();
  const { search } = window.location;

  const onCloseModal = () => {
    navigate(mediaCenterFolderPath(folderUuid) + search);
  };

  return (
    <FilePreview
      file={null}
      isLoading={!fileNotFound}
      onCloseModal={onCloseModal}
      screenReadersCloseButtonText={s__(
        'MediaCenterAccessibility|Close preview of media center file',
      )}
    />
  );
};

export default LoadingOrNotFound;
